const bufferTimeApiErrorMappings = {
  issueCode: {
    'BUFFER_TIME.ALREADY_EXIST': 'setting.bufferTime.error.isRouteVehicleCombinationExists',
  },
}

export default bufferTimeApiErrorMappings
